import { useCallback, useState } from "react";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import SLSListTableComponent from "./sls-list-table.component";
import { useQuery } from "@tanstack/react-query";
import { getSLS } from "../../../../../core/api/services/sls.service";

const SLSListComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [slsSearchValue, setSLSSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("name"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    /*     {
      title: "Code",
      label: "code",
      isSorted: true,
    }, */
    {
      title: "Name",
      label: "name",
      isSorted: true,
    },
    {
      title: "Address",
      label: "address",
      type: "scrollable-html",
    },
  ]);

  const {
    data: sls,
    isLoading: isLoadingSls,
    refetch,
  } = useQuery({
    queryKey: ["getSLS", PageNumber, SortBy, SortDirection, slsSearchValue],
    queryFn: ({ signal }) =>
      getSLS(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        slsSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (sls?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setSLSSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <SLSListTableComponent
        columns={columns}
        data={sls?.data}
        totalNumberOfRecords={sls?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingSls}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default SLSListComponent;
